import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createStatCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/statCardBlockHelper";
import { getHomepageBlockPrimaryStyleOptions } from "../constants";

const stats = [
  {
    number: "94%",
    text: "Client satisfaction rate",
  },
  {
    number: "150+",
    text: "Executive coaches",
  },
  {
    number: "12+",
    text: "Years of experience",
  },
  {
    number: "30+",
    text: "Industries served",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HomepageBlock5",
  props: {
    content: {
      prop: "children",
      type: "children",
      value: stats.map(stat => createStatCardBlock(stat)),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getHomepageBlockPrimaryStyleOptions(),
      },
    },
  },
};
